export default "__VITE_ASSET__DuWqs5v6__"